import React, { Fragment } from 'react';

import {
  StyledInputContainer,
  StyledLabelP,
  StyledLabelStrongP,
  StyledPasswordLabelP,
  StyledInput,
  StyledActionsContainer,
  StyledButton,
  ButtonContainerStyled,
  LinkButtonContainerStyled,
  StyledLinkButton,
} from 'helpers/StyledLoginComponentsHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

export default props => {
  const { details } = props;

  const mobileNumberInState = details.mobileNumber;
  let lastFourDigitsMobile = props.loginErrorData.mobileNumber;
  if (mobileNumberInState && mobileNumberInState.length === 10) {
    lastFourDigitsMobile = lastFourDigitsMobile.substring(6, 10);
  }
  return (
    <Fragment>
      <StyledInputContainer>
        <StyledLabelP>
          {getTranslatedString('login.sentVerificationCode')}{' '}
          {details.verificationMethod === 'mobile'
            ? `${getTranslatedString('login.lastFourMobileNumber')} ${lastFourDigitsMobile}`
            : getTranslatedString('login.yourEmail')}
        </StyledLabelP>

        <StyledPasswordLabelP>{getTranslatedString('verificationCode')}</StyledPasswordLabelP>

        <StyledInput
          name="verificationCode"
          type="text"
          placeholder={getTranslatedString('verificationCode')}
          onChange={props.handleInputChange}
          value={details.verificationCode}
          onKeyDown={props.detectEnterKeyDown}
        />
      </StyledInputContainer>

      <StyledActionsContainer mobile={props.mobile}>
        <ButtonContainerStyled mobile={props.mobile}>
          <StyledButton
            name="submit"
            inputProps={{ 'aria-label': getTranslatedString('login') }}
            data-testid="login-button"
            id={'login-button'}
            primary={true}
            onClick={props.login}
            accentColor={AccentColor()}
            disabled={!details.isButtonEnabled}
            labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
            mobile={props.mobile}
          >
            {getTranslatedString('login')}
          </StyledButton>
        </ButtonContainerStyled>
      </StyledActionsContainer>
      <StyledActionsContainer>
        <StyledLabelStrongP>{getTranslatedString('login.didntReceiveCode')} </StyledLabelStrongP>

        <LinkButtonContainerStyled mobile={props.mobile}>
          <StyledLinkButton style={{ width: '100%' }} onClick={props.resetVerificationCode}>
            {getTranslatedString('login.tryAgain')}
          </StyledLinkButton>
        </LinkButtonContainerStyled>

        <LinkButtonContainerStyled mobile={props.mobile}>
          <StyledLinkButton style={{ width: '100%' }} onClick={props.showAlternative}>
            {getTranslatedString('login.tryAnotherWay')}
          </StyledLinkButton>
        </LinkButtonContainerStyled>
      </StyledActionsContainer>
    </Fragment>
  );
};
